import React from 'react';
import { Link } from 'react-router-dom';
import './LiveMusic.css';
import liveMusicPoster from '../assets/live-music/live-music-poster.png';

const LiveMusic = () => {
  return (
    <div className="live-music-page">
      <div className="live-music-container">
        <div className="live-music-content">
          <h1 className="live-music-title">Live Music</h1>
          <div className="live-music-time">Every Thursday at 6 PM</div>

          <div className="live-music-description">
            <p>
              Wind down your week with us. Every Thursday evening, Drake's fills with live
              acoustic sets while our full dinner menu, craft cocktails, and house made
              desserts are served.
            </p>

            <div className="live-music-details">
              <div className="live-music-detail">
                <h3>What to Expect</h3>
                <p>Local musicians performing live from 6 PM, right alongside dinner service
                in our dining room.</p>
              </div>

              <div className="live-music-detail">
                <h3>No Cover</h3>
                <p>Free to attend — just come in, grab a table or a seat at the bar, and enjoy
                the show.</p>
              </div>

              <div className="live-music-detail">
                <h3>Seating</h3>
                <p>Thursday nights fill up fast. Reserve a table ahead of time to make sure you
                have a spot.</p>
              </div>

              <div className="live-music-detail">
                <h3>Musicians — Bookings Are Open</h3>
                <p>Want to play at Drake's? We're booking Thursday slots now. Email us at{' '}
                <a href="mailto:drakesstaff@gmail.com?subject=Live%20Music%20Booking%20-%20Drake's%20San%20Carlos">
                drakesstaff@gmail.com</a> to get on the calendar.</p>
              </div>
            </div>

            <div className="live-music-buttons">
              <Link to="/reservations" className="live-music-cta-button">Reserve a Table</Link>
              <a
                href="mailto:drakesstaff@gmail.com?subject=Live%20Music%20Booking%20-%20Drake's%20San%20Carlos"
                className="live-music-details-button"
              >
                Book a Performance
              </a>
            </div>
          </div>
        </div>

        <div className="live-music-poster-container">
          <img
            className="live-music-poster"
            src={liveMusicPoster}
            alt="Drake's San Carlos Live Music every Thursday 6 PM — bookings are open, more information at drakesstaff@gmail.com"
          />
        </div>
      </div>
    </div>
  );
};

export default LiveMusic;
